import React from "react"
import { isEmpty } from "lodash-es"
import { useUserActionAuditTrailContext } from "contexts/UserActionAuditTrailContext"
import LoadingIndicator from "shared/LoadingIndicator"
import LoadMoreButton from "./LoadMoreButton"
import UserActionAuditTrailGroups from "./UserActionAuditTrailGroups"

const INDICATOR_TEXT = "Loading user activity ..."

const Content = () => {
  const { auditGroups, initialAuditsLoaded, isLoading } = useUserActionAuditTrailContext()

  if (isLoading && !initialAuditsLoaded) {
    return (<LoadingIndicator textValue={INDICATOR_TEXT} />)
  }

  if (isEmpty(auditGroups) && !isLoading) {
    return (
      <p className="mb-12">
        User has no activity to display.
      </p>
    )
  }

  return (
    <>
      <UserActionAuditTrailGroups />
      {
        isLoading ? <LoadingIndicator /> : <LoadMoreButton />
      }
    </>
  )
}

export default Content
